import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { productosPath } from 'src/app/shared/helpers/constants';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class InvAuthGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isLoggedIn()) {
      this.router.navigate([productosPath.path]);
    }
    return true;
  }
}
